export { default } from './VehicleInfoCard';
